"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = void 0;
var React = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var styles_1 = require("@material-ui/core/styles");
var defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    button: "span",
};
var extraVariantMapping = {
    display1SemiBold: "h1",
    display1Bold: "h1",
    display1ExtraBold: "h1",
    display2SemiBold: "h1",
    display2Bold: "h1",
    display2ExtraBold: "h1",
    h1SemiBold: "h1",
    h1Bold: "h1",
    h1ExtraBold: "h1",
    h2SemiBold: "h2",
    h2Bold: "h2",
    h2ExtraBold: "h2",
    h3SemiBold: "h3",
    h3Bold: "h3",
    h3ExtraBold: "h3",
    h4SemiBold: "h4",
    h4Bold: "h4",
    h4ExtraBold: "h4",
    h5SemiBold: "h5",
    h5Bold: "h5",
    h5ExtraBold: "h5",
    h6SemiBold: "h6",
    h6Bold: "h6",
    h6ExtraBold: "h6",
    subtitle1MediumItalic: "h6",
    subtitle1Medium: "h6",
    subtitle1SemiBold: "h6",
    subtitle2SemiBold: "h6",
    subtitle2Medium: "h6",
    subtitle2MediumItalic: "h6",
    subtitle3Medium: "h6",
    subtitle3MediumItalic: "h6",
    subtitle3SemiBold: "h6",
    body1Medium: "p",
    body1SemiBold: "p",
    body2Medium: "p",
    body2SemiBold: "p",
    body3Medium: "p",
    body3SemiBold: "p",
    overlineLarge: "span",
    overlineMedium: "span",
    overlineSmall: "span",
    captionMedium: "span",
    captionSemiBold: "span",
    buttonV2: "span",
    buttonSmall: "span",
    buttonMedium: "span",
    buttonLarge: "span",
    displayLargeSemiBoldInter: "h1",
    displayLargeBoldInter: "h1",
    displayLargeExtraBoldInter: "h1",
    displayMediumSemiBoldInter: "h1",
    displayMediumBoldInter: "h1",
    displayMediumExtraBoldInter: "h1",
    displaySmallSemiBoldInter: "h1",
    displaySmallBoldInter: "h1",
    displaySmallExtraBoldInter: "h1",
    h1SemiBoldInter: "h1",
    h1BoldInter: "h1",
    h1ExtraBoldInter: "h1",
    h2SemiBoldInter: "h2",
    h2BoldInter: "h2",
    h2ExtraBoldInter: "h2",
    h3SemiBoldInter: "h3",
    h3BoldInter: "h3",
    h3ExtraBoldInter: "h3",
    h4SemiBoldInter: "h4",
    h4BoldInter: "h4",
    h4ExtraBoldInter: "h4",
    h5SemiBoldInter: "h5",
    h5BoldInter: "h5",
    h5ExtraBoldInter: "h5",
    h6SemiBoldInter: "h6",
    h6BoldInter: "h6",
    h6ExtraBoldInter: "h6",
    subtitle1RegularInter: "p",
    subtitle1RegularItalicInter: "p",
    subtitle1SemiBoldInter: "p",
    subtitle1SemiBoldItalicInter: "p",
    subtitle2RegularInter: "p",
    subtitle2RegularItalicInter: "p",
    subtitle2SemiBoldInter: "p",
    subtitle2SemiBoldItalicInter: "p",
    subtitle3RegularInter: "p",
    subtitle3RegularItalicInter: "p",
    subtitle3SemiBoldInter: "p",
    subtitle3SemiBoldItalicInter: "p",
    body1RegularInter: "p",
    body1MediumInter: "p",
    body1SemiBoldInter: "p",
    body1ItalicInter: "p",
    body1UnderlineInter: "p",
    body1LineThroughInter: "p",
    body2RegularInter: "p",
    body2MediumInter: "p",
    body2SemiBoldInter: "p",
    body2ItalicInter: "p",
    body2UnderlineInter: "p",
    body2LineThroughInter: "p",
    body3RegularInter: "p",
    body3MediumInter: "p",
    body3SemiBoldInter: "p",
    body3ItalicInter: "p",
    body3UnderlineInter: "p",
    body3LineThroughInter: "p",
    body4RegularInter: "p",
    body4MediumInter: "p",
    body4SemiBoldInter: "p",
    body4ItalicInter: "p",
    body4UnderlineInter: "p",
    body4LineThroughInter: "p",
    overlineSmallInter: "span",
    overlineMediumInter: "span",
    overlineLargeInter: "span",
    captionMediumInter: "span",
    captionSemiBoldInter: "span",
    buttonSmallInter: "span",
    buttonMediumInter: "span",
    buttonLargeInter: "span",
    buttonSmallUpperInter: "span",
    buttonMediumUpperInter: "span",
    buttonLargeUpperInter: "span",
};
var getExtraVariantClasses = function (theme) {
    return Object.fromEntries(Object.keys(extraVariantMapping).map(function (variant) { return [
        variant,
        theme.typography[variant],
    ]; }));
};
var styles = function (theme) { return (__assign(__assign({ root: {
        margin: 0,
    }, noWrap: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    }, gutterBottom: {
        marginBottom: "0.35em",
    } }, getExtraVariantClasses(theme)), { colorInitial: {
        color: "initial",
    }, colorPrimary: {
        color: theme.palette.primary.main,
    }, colorSecondary: {
        color: theme.palette.secondary.main,
    }, colorTextPrimary: {
        color: theme.palette.text.primary,
    }, colorTextSecondary: {
        color: theme.palette.text.secondary,
    }, colorError: {
        color: theme.palette.error.main,
    } })); };
var useStyles = styles_1.makeStyles(styles);
exports.Typography = React.forwardRef(function (props, ref) {
    var _a;
    var children = props.children, className = props.className, _b = props.color, color = _b === void 0 ? "inherit" : _b, component = props.component, _c = props.gutterBottom, gutterBottom = _c === void 0 ? false : _c, _d = props.noWrap, noWrap = _d === void 0 ? false : _d, _e = props.variant, variant = _e === void 0 ? "body1" : _e, style = props.style;
    var classes = useStyles();
    if (variant in defaultVariantMapping) {
        return React.createElement(Typography_1.default, __assign({}, props, { variant: variant }));
    }
    var Component = component || extraVariantMapping[variant];
    return (React.createElement(Component, { className: clsx_1.default(classes.root, classes[variant], (_a = {},
            _a[classes["color" + capitalize(color)]] = color !== "inherit",
            _a[classes.noWrap] = noWrap,
            _a[classes.gutterBottom] = gutterBottom,
            _a), className), style: style, ref: ref }, children));
});
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
